<template>
	<div class="container">
		<div class="content">
			<div class="card">
				<h3 class="title mb_20">인증 관리</h3>
				<SecurityInfo></SecurityInfo>

				<div class="item_box mb_5">
					<h4>
						<span><img src="@/assets/images/icon/1.png" alt="" /></span> 이메일
						인증
					</h4>
					<div class="mt_20">
						<Email></Email>
					</div>
				</div>

				<div class="item_box mb_5">
					<h4>
						<span><img src="@/assets/images/icon/2.png" alt="" /></span> KYC
						인증
					</h4>
					<div class="mt_20">
						<Kyc></Kyc>
					</div>
				</div>

				<div class="item_box mb_5">
					<h4>
						<span><img src="@/assets/images/icon/2.png" alt="" /></span> OTP
						인증
					</h4>
					<div class="mt_20">
						<Otp></Otp>
					</div>
				</div>

				<!--				<div class="item_box">-->
				<!--					<h4>-->
				<!--						<span><img src="@/assets/images/icon/4.png" alt="" /></span>-->
				<!--						출금주소 인증-->
				<!--					</h4>-->
				<!--					<div class="mt_20">-->
				<!--						<Address></Address>-->
				<!--					</div>-->
				<!--				</div>-->

				<div v-if="0" class="information">
					<p class="mb_10">{{ $t('merchant.security.title3') }}</p>
					<ul>
						<li>- {{ $t('merchant.security.text1') }}</li>
						<li>- {{ $t('merchant.security.text2') }}</li>
						<li>- {{ $t('merchant.security.text3') }}</li>
						<li>- {{ $t('merchant.security.text4') }}</li>
					</ul>
				</div>

				<!--				<ul class="tab_area mb_10">-->
				<!--					<li-->
				<!--						:class="{ selected: selectedTab === 'email' }"-->
				<!--						@click="selectedTab = 'email'"-->
				<!--					>-->
				<!--						<a>이메일 인증</a>-->
				<!--					</li>-->
				<!--					<li-->
				<!--						:class="{ selected: selectedTab === 'kyc' }"-->
				<!--						@click="selectedTab = 'kyc'"-->
				<!--					>-->
				<!--						<a>KYC 인증</a>-->
				<!--					</li>-->
				<!--					<li-->
				<!--						:class="{ selected: selectedTab === 'otp' }"-->
				<!--						@click="selectedTab = 'otp'"-->
				<!--					>-->
				<!--						<a>OTP 인증</a>-->
				<!--					</li>-->
				<!--					&lt;!&ndash;					<li><a>출금 주소 인증</a></li>&ndash;&gt;-->
				<!--					<li-->
				<!--						:class="{ selected: selectedTab === 'security' }"-->
				<!--						@click="selectedTab = 'security'"-->
				<!--					>-->
				<!--						<a>보안 등급</a>-->
				<!--					</li>-->
				<!--				</ul>-->

				<div>
					<div v-if="selectedTab === 'email'">
						<!--						<Email></Email>-->
					</div>
					<div v-if="selectedTab === 'kyc'">
						<Kyc></Kyc>
					</div>
					<div v-if="selectedTab === 'otp'">
						<Otp></Otp>
					</div>
					<div v-if="selectedTab === 'security'">
						<Security></Security>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import SecurityInfo from '@/components/Mypage/SecurityInfo';
import Email from '@/components/Mypage/Certification/Email';
import Kyc from '@/components/Mypage/Certification/Kyc';
import Otp from '@/components/Mypage/Certification/Otp';
import Security from '@/components/Mypage/Certification/Security';
export default {
	name: 'Certification.m',
	components: {
		Security,
		SecurityInfo,
		Email,
		Kyc,
		Otp,
	},
	data() {
		return {
			selectedTab: 'email',
		};
	},
};
</script>

<style scoped></style>
